export default {
  audio: 'audio',
  archives: 'archives',
  book: 'book',
  coin: 'coin',
  collection: 'collection',
  'data file': 'data-file',
  dissertation: 'dissertation',
  ebook: 'book',
  film: 'film',
  journal: 'journal',
  'journal article': 'text',
  manuscript: 'manuscript',
  map: 'map',
  'mixed material': 'mixed-material',
  'musical score': 'musical-score',
  'news clippings': 'text',
  newspaper: '\f608',
  posters: 'visual-material',
  'senior thesis': 'senior-thesis',
  'Video/Projected medium': 'video-projected-medium',
  'visual material': 'visual-material'
};
